enum VatNumberOption {
  VAT_NBR = 'VAT_NBR',
  VAT_NBR_PEND = 'VAT_NBR_PEND',
  IN_BUSNS_CONF = 'IN_BUSNS_CONF',
}
export default VatNumberOption;
